import React, { useState, useEffect, useContext } from 'react';

import FormService from "../../../Setup/controller/FormController/FormController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link, useNavigate } from 'react-router-dom';
import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import Common from '../../../Common/Common';
import handleSubmitForCheckbox from "../../../SuperAdmin/Controller/AssignFormController/AssignFormController";
function FormListPage() {
    const navigate = useNavigate();
    const [formList, setForms] = useState([]);
    const { t, i18n } = useTranslation();
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [checkboxState, setCheckboxState] = useState({});
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setCheckboxState({ ...checkboxState, [name]: checked });
    };

    const getParamsFromQueryString = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const params = {};
        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
        return params;
    };

    const params = getParamsFromQueryString();
    const ClientID = params['ClientID'];
    const RoleID = params['RoleID'];


    const handleSubmitForm = async () => {

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };

        try {
            await handleSubmitForCheckbox(ClientID, RoleID, checkboxState, redirectCallback);
            navigate(`/FormRole?ClientID=${ClientID}&RoleID=${RoleID}`);
        } catch (error) {
            console.error('Error handling form submission:', error);
            // Handle error (e.g., display an error message)
        }
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };
                const formData = await FormService.GetAllFormsWihClient(redirectCallback, ClientID, RoleID); // Pass the language parameter
                setForms(formData[0]);

                const initialState = {};
                formData[0].forEach(form => {
                    initialState[form.ID] = form.RoleID !== null;
                });
                console.log("intitalstate", initialState);
                setCheckboxState(initialState);
            } catch (error) {
                console.error('Error fetching Users:', error);
            }
        }
        fetchData();
    }, [i18n.language]); // Listen to changes in language

    return (
        <div>
             <Common />
            <div className="main-content-header">
                <h1>Select Forms</h1>
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            <div className="row mb-3">
                                <Link className='btn btn-secondary' to={`/FormRole?ClientID=${ClientID}&RoleID=${RoleID}`} style={{ "marginLeft": "5px" }}>
                                    <i className='bi bi-plus-lg'></i>
                                    Back
                                </Link>

                            </div>
                            <table className="table datatable table-bordered">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Form Name</th>
                                        <th>Module Name</th>

                                    </tr>
                                </thead><tbody>
                                    {formList.map(form => (
                                        <tr>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    name={form.ID}
                                                    checked={checkboxState[form.ID] || false}
                                                    onChange={handleCheckboxChange}
                                                />
                                            </td>
                                            <td>{form.FormName}</td>
                                            <td>{form.vc_ModuleName}</td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div>

                                <button type="button" onClick={handleSubmitForm} className="btn btn-primary">Assign</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FormListPage;